import React, { memo, useEffect, useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { Layout, Button } from "antd";
import useStores, { observer, toJS } from "stores";
import LayoutHeader from "layout/mainLayout/header";
import MenuList from "./menuList";
import BreadcrumbComp from "./breadcrumbComp";
import {
	MenuFoldOutlined,
	MenuUnfoldOutlined,
} from "@ant-design/icons";

import "./index.scss";

const MainLayout = () => {
	const { pathname } = useLocation();
	const [collapsed, setCollapsed] = useState(false);

	const { authStore, commonStore } = useStores();
	const { isCheckUserInfo } = authStore;
	const { defaultMenu, menuList } = commonStore;

	useEffect(() => {
		const urlArry = pathname?.split("/").slice(1);
		//console.log("urlArry:", urlArry);
		// 새로고침시 menuList.length 0 방지
		if(urlArry?.[0] && menuList?.length > 0) {
			const checkAuth = menuList.find(item => item.key === urlArry?.[0]);
			//console.log("menuList:", toJS(menuList));
			//console.log("checkAuth:", checkAuth);
			if(!checkAuth) {
				console.log("권한없음으로 이동 ---------  ");
				return window.location.href = "/error/403";
			}
		}
	}, [pathname, menuList]);


	const toggleCollapsed = () => {
		setCollapsed(!collapsed);
	};

	if (isCheckUserInfo()) {
		if (pathname === "/" || pathname === "/singup") {
			if(menuList.length > 0)	return <Navigate to={"/" + defaultMenu} replace />;
		}
		return (
			<Layout className="layout-page">
				<LayoutHeader collapsed={collapsed} toggle={toggleCollapsed} />
				<Layout style={{ padding: "10px" }}>
					<Layout.Sider
						className="layout-page-sider"
						theme={"light"}
						trigger={
							<div
								style={{
									display: "flex",
									justifyContent: "flex-end",
									padding: "0px",
								}}
							>
								<Button
									type="text"
									style={{ padding: 0, lineHeight: 1 }}
									onClick={toggleCollapsed}
								>
									{collapsed ? (
										<MenuUnfoldOutlined
											style={{ fontSize: 20, color: "#4380f8" }}
										/>
									) : (
										<MenuFoldOutlined
											style={{ fontSize: 20, color: "#4380f8" }}
										/>
									)}
								</Button>
							</div>
						}
						collapsible
						collapsed={collapsed}
					>
						<MenuList />
					</Layout.Sider>
					<Layout.Content className="layout-page-content">
						{/* <Tabtag /> */}
						<div style={{ padding: "4px" }}>
							<BreadcrumbComp />
						</div>
						<Outlet />
					</Layout.Content>
				</Layout>
			</Layout>
		);
	}
	if (pathname !== "/" && pathname !== "/singup")
		return <Navigate to="/" replace />;
	return <Outlet />;
};

export default memo(observer(MainLayout));
